<template>
    <div>
        <div class="controls-top d-none" ref="controlsTop" v-show="numSoundFiles < maxRecordings && step == 1">
            <div>Sound Recorder</div>
            <div :class="{
                    'text-2xl font-italic': initUserMedia,
                    'text-4xl font-bold': !initUserMedia && !markCountdown,
                    'text-4xl font-bold text-orange': !initUserMedia && markCountdown
                }">
                {{ initUserMedia ? 'Aufnahme vorbereiten...' : recordingDuration }}
            </div>
        </div>
        <div class="stage-wrapper">
            <div class="stage-spacer flex" ref="stageSpacer" v-show="step < 5"
                :class="{
                    'is-empty': numSoundFiles == 0,
                    'is-countdown': !initUserMedia && isCountdown,
                    'is-recording': !initUserMedia && isRecording,
                    'recording-finished': theme == 'Love' && numSoundFiles == 2,
                    'is-love': theme == 'Love',
                    'on-top': step == 1 && !cropModeActive,
                    'flex-row': theme == 'Love',
                    'flex-column': theme != 'Love'
                    // 'pulsing-shadow': animate
                }">

                <div class="h-full w-full flex items-center playback-control-wrapper" v-show="step == 1 && numSoundFiles != 0"
                    v-for="soundFile in soundFiles" :key="soundFile">
                    <div class='playback-control h-full w-full items-center justify-center flex'>
                        <Player :record="soundFile" name="playWhite" icon-background="true"></Player>
                    </div>
                </div>
                <div class="h-full w-full flex items-center playback-control-wrapper" v-show="step == 1 && numSoundFiles == 0">
                    <div class='playback-control h-full w-full items-center justify-center flex'>
                        <div class="headline" :class="{ 'has-subline': animate }">{{ recordButtonHeadline }}</div>
                        <div class="subline" :class="{ 'danger': (7 - recordingDurationInt) < 4 }" v-if="animate">noch {{ (7 - recordingDurationInt) }} sek verbleibend</div>
                        <div v-if="!isRecording" class="start-record-btn" @click="startRecorder"></div>
                        <Countdown :duration="3" v-else-if="!initUserMedia && isCountdown"></Countdown>
                        <div v-else class="stop-record-btn" :class="{'recording': !initUserMedia}" ref="stopRecordBtn" @click="stopRecorder">
                            <span class="number" v-if="!initUserMedia">{{ recordingDurationInt }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="stage-container">
                <div class="wave-preview-container" ref="previewContainer">
                    <div id="ayv-stage"></div>
                </div>
            </div>
        </div>

        <div class="controls-bottom" v-show="(numSoundFiles >= maxRecordings) && (step == 1)" ref="controlsBottom">
            <div v-show="numSoundFiles >= maxRecordings && step == 1">
                <div>
                    <CropAmplitude :open="false"></CropAmplitude>
                </div>
            </div>
            <div v-show="numSoundFiles < maxRecordings && step == 1" class="d-none">
                <div>
                    <Recorder
                        :afterRecording="afterRecording"
                        :micFailed="micFailed"
                        format="mp3"
                        :sample-rate="48000"
                        :bit-rate="128"
                        :time="7"
                        :btn-inline="nextSoundFile > 1 && maxRecordings > 2"
                        :btn-primary="true"
                        ref="soundRecorder"
                    >
                        <template slot="StartBtnLabel" v-if="maxRecordings > 1">Aufnahme {{ nextSoundFile }} starten</template>
                        <template slot="StartBtnLabel" v-else>Stimme aufnehmen</template>
                    </Recorder>
                    <span v-show="nextSoundFile > 1 && maxRecordings > 2"><button class="btn btn-primary--brand uppercase" @click="step=step+1">Weiter</button></span>
                </div>
                <!-- <div v-show="!isRecording">
                    <div class="text-or p-2">oder</div>
                    <div>
                        <button class="btn btn-primary--brand btn-upload uppercase" @click="uploadFile">Datei hochladen (Max. 3MB)</button>
                        <input type="file" ref="fileUpload" accept="audio/mpeg,audio/wav" hidden>
                    </div>
                </div> -->
            </div>
            <div v-show="(numSoundFiles >= maxRecordings) || (step > 1)" class="d-none">
                <div>
                    <button v-show="step > 1" @click="navigateBack()" class="btn btn-primary--brand uppercase"
                        :class="{'mr-1': step < 2}">Zurück</button>
                    <button class="btn btn-primary--brand uppercase" @click="navigateForward()"
                        :class="{'w-72 ml-1': step < 2}">Weiter</button>
                </div>
                <!--<div v-show="numSoundFiles > 0">
                    <div class="text-or p-2">oder</div>
                    <div>
                        <a class="btn btn-primary--brand btn-upload uppercase" href="#" @click="removeRecord">Stimme neu aufnehmen</a>
                        <a v-show="!justSaved" class="btn btn-primary--brand btn-upload" href="#" @click="saveProject">speichern</a>
                        <a v-show="justSaved" class="m-1 animate-pulse btn btn-primary--brand btn-upload" href="#" @click="saveProject">gespeichert</a>
                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import Countdown from "./Countdown.vue";
import { mapFields } from 'vuex-map-fields';
import Pipeline from '~/scripts/Pipeline/Pipeline.js';
import CropAmplitude from "./../../ControlPanel/2_WaveConfiguration/CropAmplitude.vue";
import Player from "./../../ControlPanel/1_SoundConfiguration/Player.vue";
import Recorder from './../../ControlPanel/1_SoundConfiguration/Recorder.vue';

export default {
    components: {
        Player,
        Recorder,
        Countdown,
        CropAmplitude
    },
    computed: {
        ...mapFields({
            step: 'step',
            substep: 'substep',
            theme: 'theme.title',
            stageScale: 'stageScale',
            soundFiles: 'soundFiles',
            isRecording: 'isRecording',
            isCountdown: 'isCountdown',
            cropModeActive: 'cropModeActive',
            maxRecordings: 'theme.maxRecordings',
            stageScaleChanged: 'stageScaleChanged',
            recordingVolume: 'recordingVolume',
            recordingDuration: 'recordingDuration',
            availableSubsteps: 'availableSubsteps',
            soundFilesChanged: 'soundFilesChanged',
            initUserMedia: 'initUserMedia'
        }),

        numSoundFiles() {
            return this.soundFiles.length;
        },

        recordButtonHeadline() {
            if (this.isRecording) {
                if (this.initUserMedia) {

                    return "Aufnahme vorbereiten...";
                }
                else if (this.isCountdown) {
                    return "Aufnahme startet in";
                }

                return "Deine Aufnahme";
            }

            return "Aufnahme starten";
        },

        recordingDurationInt() {
            return this.recordingDuration
        },

        nextSoundFile() {
            const removedIndex = this.$store.state.removedIndex;
            return removedIndex !== null ? removedIndex + 1 : this.numSoundFiles + 1;
        },

        animate() {
            return this.isRecording && !this.isCountdown && !this.initUserMedia;
        },

        markCountdown() {
            return this.recordingDuration.substr(0, 1) == '-';
        }
    },

    data() {
        return {
            justSaved: false
        };
    },

    mounted() {
        let self = this;

        Pipeline.runPipeline();
        this.calculateStageSize();

        // when a sound file was uploaded
        // this.$refs.fileUpload.addEventListener('change', async function() {
        //     var file = this.files[0];
        //     var objectUrl = self.createObjectURL(file);
        //     var duration = await self.getAudioDuration(objectUrl);

        //     let soundFile = {
        //         url: objectUrl,
        //         duration: duration,
        //         isUpload: true
        //     };

        //     self.$store.commit('addSoundFile', soundFile);
        // });
    },

    methods: {
        /**
         * When the user recorded a voice, add the file to the vuex store
         * @param recording
         */
        afterRecording(recording) {
            // // add to store
            this.$store.commit('addSoundFile', recording);

            // commit event on root element
            let element = document.getElementById('ayv-container');
            element.dispatchEvent(new CustomEvent("soundRecordsChanged", {
                detail: {
                    soundFiles: this.$store.state.soundFiles
                }
            }));
        },

        startRecorder() {
            this.$root.$emit('startRecorder');
        },

        stopRecorder() {
            if (!this.isCountdown) {
                this.$root.$emit('stopRecorder');
            }
        },

        micFailed() {
            alert('Ihr Mikrofon kann leider nicht aktiviert werden. Bitte heben Sie die Blockierung des Mikrofons in Ihrem Browser auf und versuchen es erneut!');
            this.isRecording = false;
            this.isCountdown = false;
            this.initUserMedia = false;
        },

        uploadFile() {
            // this.$refs.fileUpload.click();
        },

        calculateStageSize() {
            const stage = this.$store.state.stage;
            const stageSpacer = this.$refs.stageSpacer;
            const previewContainer = this.$refs.previewContainer;

            if (stage) {
                stageSpacer.style.cssText = `
                    height: ${(stage.height() * this.stageScale)}px;
                    width: ${(stage.width() * this.stageScale)}px;
                `;

                previewContainer.style.cssText = `
                    transform: scale3d(${this.stageScale}, ${this.stageScale}, ${this.stageScale});
                    margin-top: ${((stage.height() / 2) * -1)}px;
                    margin-left: ${((stage.width() / 2) * -1)}px;
                `;
            }
        },

        /**
         * Convert a File into an object url
         * @param file File
         */
        createObjectURL(file) {
            if ( window.webkitURL ) {
                return window.webkitURL.createObjectURL( file );
            } else if ( window.URL && window.URL.createObjectURL ) {
                return window.URL.createObjectURL( file );
            } else {
                return null;
            }
        },

        async getAudioDuration(file) {
            return new Promise((resolve, reject) => {
                var audioElement = new Audio();

                audioElement.addEventListener('canplaythrough', function(e) {
                    let seconds = e.currentTarget.duration
                    var date = new Date(seconds * 1000); // multiply by 1000 because Date() requires milliseconds
                    var time = date.toTimeString().split(' ')[0].split(':');
                    // remove hour (which can be off anyway, depending on the timezone)
                    // ..and just keep minutes and seconds
                    time.splice(0, 1);
                    resolve(time.join(':'));
                });
                audioElement.src = file;
            });
        },

        navigateForward() {
            let element = document.getElementById('ayv-configurator-modal');
            element.dispatchEvent(new CustomEvent("navigateForward"));
        },

        navigateBack() {
            let element = document.getElementById('ayv-configurator-modal');
            element.dispatchEvent(new CustomEvent("navigateBack"));
        },

        removeRecord() {
            this.step = 1;
            this.$store.commit('removeSoundFile', 0);
            this.$store.commit('updateField', {
                path: 'recordingDuration',
                value: '0'
            });
        },

        async saveProject() {
            // do not save repeatedly
            if(this.justSaved) return;

            await this.$store.commit('saveState');

            this.justSaved = true;

            window.setTimeout(() => {
                this.justSaved = false;
            }, 5000);
        },
    },
    watch: {
        soundFilesChanged() {
            if (this.soundFilesChanged) {
                Pipeline.setResponsiveStageWidth();
                Pipeline.soundFilesToWaveForm(true);
                Pipeline.updateStageBorder();

                if (this.soundFiles.length > 0) {
                    setTimeout(() => {
                        this.$root.$emit('activateCropMode');
                    }, 150);
                }

                this.$store.commit('updateField', {
                    path: 'soundFilesChanged',
                    value: false
                });
            }
        },

        step() {
            Pipeline.setResponsiveStageWidth();
            Pipeline.setResponsivePreviewSize();
        },

        stageScaleChanged() {
            if (this.stageScaleChanged) {
                this.calculateStageSize();
            }

            this.stageScaleChanged = false;
        },

        recordingVolume() {
            if (this.$refs.stopRecordBtn) {
                if (this.recordingVolume  == 0) {
                    this.$refs.stopRecordBtn.style.boxShadow = 'none'
                }

                const volumeMax = 0.18;
                const volumePercentage = this.recordingVolume / volumeMax;
                const shadowAddition = volumePercentage * 15;

                this.$refs.stopRecordBtn.style.boxShadow = `0 0 10px ${ 2 + shadowAddition }px #bc6c25`
            }
        }
    },
}
</script>
